import { PublicModule } from './public/public.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppConfigService } from './app-config.service';
import {
  TranslateModule,
  TranslateLoader,
} from '@ngx-translate/core';
import { HttpBackend, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import {
  initConfigFactory,
  httpLoaderFactory,
  keycloakFactory,
} from './app-init';
import { NoCacheHeadersInterceptor } from './core/services/interceptor';
import { NgChartsModule } from 'ng2-charts';
import { ToasterComponent } from 'src/app/layout/components/toast/toast.component';
import { UserService } from './core/services/user.service';
import { MerchantsContextsModule } from './contexts-merchants/merchants-contexts.module';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Router } from '@angular/router';
// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import { CoreModule } from './core/core.module';
// register Swiper custom elements
register();

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    KeycloakAngularModule,
    PublicModule,
    CoreModule,
    ToastrModule.forRoot({
      disableTimeOut: true,
      positionClass: 'toast-bottom-full-width',
      preventDuplicates: true,
      toastComponent: ToasterComponent,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpBackend],
      },
    })
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfigFactory,
      deps: [AppConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: keycloakFactory,
      multi: true,
      deps: [KeycloakService, UserService, Router, AppConfigService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor() { }
}
